import { PayloadAction } from '@reduxjs/toolkit';

import { ExtraReducerBuilder } from '../../types/shared';
import { WritableQuoteBuilderStateType } from '../../types/state';
import { createNewPartUserPriceQuoteLine } from '../endpoints/create-new-part-user-price-quote-line';
import { transformPartialQuoteLineWithDefaults } from '../utilities/transform-quote-line';
import { withSaveStateUpdate } from '../utilities/with-save-state-update';

function createNewPartUserPriceQuoteLineFulfilled(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<
    typeof createNewPartUserPriceQuoteLine.Types.ResultType
  >,
) {
  const quoteLine = transformPartialQuoteLineWithDefaults(
    action.payload,
    state,
  );

  state.quoteLineUuids.push(quoteLine.uuid);
  state.quoteLines[quoteLine.uuid] = quoteLine;

  state.dialog = null;
}

function createNewPartUserPriceQuoteLineRejected(
  state: WritableQuoteBuilderStateType,
) {
  state.dialog = null;
}

export function createNewPartUserPriceQuoteLineReducer(
  builder: ExtraReducerBuilder,
) {
  builder.addMatcher(
    createNewPartUserPriceQuoteLine.matchFulfilled,
    withSaveStateUpdate(createNewPartUserPriceQuoteLineFulfilled),
  );
  builder.addMatcher(
    createNewPartUserPriceQuoteLine.matchRejected,
    createNewPartUserPriceQuoteLineRejected,
  );
}
